<script setup lang="ts">
import { computed } from 'vue'
import { sanitizeRichText } from '../richText'

// Shows a rich text field (UiRichTextEditor), or an old plain one with its line breaks. The HTML always
// goes through DOMPurify with the tags of richText.ts first: it came from people, and the server's
// sanitizer is not the only layer.
const props = defineProps<{ value: string | null | undefined }>()

const html = computed(() => sanitizeRichText(props.value))
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -- sanitized by DOMPurify (richText.ts) -->
  <div v-if="html" class="ui-richtext-view" v-html="html"></div>
</template>

<style scoped>
.ui-richtext-view {
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.ui-richtext-view > :deep(:first-child) {
  margin-top: 0;
}
.ui-richtext-view > :deep(:last-child) {
  margin-bottom: 0;
}
.ui-richtext-view :deep(p) {
  margin: 0 0 0.6em;
}
.ui-richtext-view :deep(h3),
.ui-richtext-view :deep(h4) {
  margin: 0.8em 0 0.4em;
  font-size: var(--type-headline-size, 1.05em);
}
.ui-richtext-view :deep(ul),
.ui-richtext-view :deep(ol) {
  margin: 0 0 0.6em;
  padding-left: 1.4em;
}
.ui-richtext-view :deep(blockquote) {
  margin: 0 0 0.6em;
  padding-left: 10px;
  border-left: 3px solid var(--separator);
  color: var(--text-secondary);
}
.ui-richtext-view :deep(a) {
  color: var(--accent);
}
</style>
